/** Joins the class names that are actually set, skipping the ones that are not. */
export function cx(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(" ");
}
